import React from 'react';
import { Button, Box, Typography, Paper } from '@mui/material';
import { Microsoft } from '@mui/icons-material';
import { useAuth } from './AuthProvider';

const LoginPage: React.FC = () => {
  const { login, loading } = useAuth();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #061535 0%, #0d2650 50%, #3966A7 100%)',
        padding: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          padding: 5,
          maxWidth: 420,
          width: '100%',
          textAlign: 'center',
          borderRadius: 4,
          background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        }}
      >
        {/* Logo AgoraSearch */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 'bold',
              fontSize: '2.5rem',
              letterSpacing: '-0.5px'
            }}
          >
            <span style={{ color: '#061535' }}>Agora</span>
            <span style={{ color: '#EF8F1C' }}>Search</span>
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: '#061535',
              fontWeight: 600,
              mt: 0.5,
              letterSpacing: '2px',
              fontSize: '0.9rem'
            }}
          >
            SIGNE+
          </Typography>
        </Box>

        {/* Ligne décorative */}
        <Box
          sx={{
            width: 80,
            height: 4,
            background: 'linear-gradient(90deg, #061535, #EF8F1C)',
            borderRadius: 2,
            mx: 'auto',
            mb: 3
          }}
        />

        <Typography
          variant="h6"
          sx={{
            color: '#061535',
            fontWeight: 500,
            mb: 1
          }}
        >
          Plateforme de recherche candidats
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Connectez-vous avec votre compte Microsoft 365 professionnel
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={login}
          disabled={loading}
          startIcon={<Microsoft />}
          fullWidth
          sx={{
            py: 1.5,
            px: 3,
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 3,
            background: 'linear-gradient(135deg, #061535 0%, #3966A7 100%)',
            boxShadow: '0 4px 15px rgba(6, 21, 53, 0.4)',
            '&:hover': {
              background: 'linear-gradient(135deg, #EF8F1C 0%, #FD4A0A 100%)',
              boxShadow: '0 6px 20px rgba(239, 143, 28, 0.5)',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          {loading ? 'Connexion en cours...' : 'Se connecter avec Microsoft'}
        </Button>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            mt: 4,
            display: 'block',
            opacity: 0.7
          }}
        >
          Accès réservé aux collaborateurs SIGNE+
        </Typography>
      </Paper>
    </Box>
  );
};

export default LoginPage;
